// @flow

import { h }             from "preact";
import { PureComponent,
         ScrollTop }     from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";

import OverviewTable from "components/OverviewTable";

@connect(
  state => ({
    cart         : state.cart,
    checkoutData : state.checkout.data,
    items        : state.cart.items,
  }),
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    grandTotal: stateProps.items.reduce((a, v) => a + v.product.price * v.qty, 0)
  })
)
export default class Review extends PureComponent {
  render({ grandTotal, items }: Props, _: any, { t }: Context) {
    return (
      items.length > 0 &&
      <section
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <header class={styles.header}>
          <h1 class={classNames(
                styles.heading,
                "h2"
              )}>

            {t("REVIEW.HEADING")}
          </h1>
        </header>

        <div class={styles.body}>
          {items.length > 0 &&
            <OverviewTable
              grandTotal={grandTotal}
              items={items} />
          }
        </div>
      </section>
    );
  }
}
